import { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { SidebarContext } from "../../../shared/context/SidebarContext";
import { toast } from "react-toastify";
import { LayoutDashboard, Copy, Plus, Trash2, Sparkles } from "lucide-react";
import { fetchDashboards, criarDashboard, excluirDashboard } from "../services/biApi";

// Lista de dashboards: modelos prontos (do código) e os seus (banco). Duplicar um modelo vira um seu, editável.

export default function AdsDashboards() {
    const { isOpen } = useContext(SidebarContext);
    const navigate = useNavigate();
    const [data, setData] = useState(null);

    async function carregar() {
        try { setData(await fetchDashboards()); } catch { toast.error("Erro ao carregar dashboards"); }
    }
    useEffect(() => { carregar(); }, []);

    async function duplicar(de, nome) {
        try {
            const d = await criarDashboard({ de, nome });
            toast.success("Dashboard criado. Agora é seu: edite à vontade.");
            navigate(`/ads/dashboards/${d.id}?editar=1`);
        } catch { toast.error("Erro ao duplicar"); }
    }
    async function novo() {
        try {
            const d = await criarDashboard({ nome: "Meu dashboard", layout: { widgets: [] } });
            navigate(`/ads/dashboards/${d.id}?editar=1`);
        } catch { toast.error("Erro ao criar"); }
    }
    async function excluir(d) {
        if (!window.confirm(`Excluir "${d.nome}"?`)) return;
        try { await excluirDashboard(d.id); toast.success("Excluído"); carregar(); } catch { toast.error("Erro ao excluir"); }
    }

    return (
        <div className="min-h-screen text-ink-1 flex relative z-0">
            <div className={`transition-all duration-300 ease-out-expo ${isOpen ? "lg:ml-64" : "sm:ml-16"} w-full max-w-full mb-16 sm:mb-0`}>
                <div className="px-5 sm:px-8 pt-8 pb-12 max-w-[1600px] mx-auto">
                    <header className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                        <div className="space-y-1">
                            <span className="label-overline text-brand-300/80">Tráfego Pago</span>
                            <h1 className="display-2 flex items-center gap-3">Dashboards <LayoutDashboard className="h-7 w-7 text-brand-400" strokeWidth={2.2} /></h1>
                            <p className="text-ink-3 text-sm">Telas prontas pra começar e as suas, montadas com os mesmos widgets.</p>
                        </div>
                        <button onClick={novo} className="btn-primary flex items-center gap-2"><Plus className="h-4 w-4" /> Novo em branco</button>
                    </header>

                    {!data && <div className="flex justify-center py-12"><div className="w-8 h-8 border-2 border-brand-400 border-t-transparent rounded-full animate-spin" /></div>}

                    {data && (
                        <div className="space-y-8">
                            <section>
                                <h2 className="heading-3 mb-3 flex items-center gap-2"><Sparkles className="h-4 w-4 text-brand-300" /> Prontos</h2>
                                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
                                    {data.modelos.map(m => (
                                        <div key={m.slug} className="surface-card surface-card-hover p-5 flex flex-col">
                                            <h3 className="font-semibold">{m.nome}</h3>
                                            <p className="text-xs text-ink-3 mt-1 flex-1">{m.descricao}</p>
                                            <div className="flex gap-2 mt-4">
                                                <Link to={`/ads/dashboards/modelo:${m.slug}`} className="btn-primary text-xs">Abrir</Link>
                                                <button onClick={() => duplicar(`modelo:${m.slug}`)} className="btn-ghost text-xs flex items-center gap-1"><Copy className="h-3.5 w-3.5" /> Duplicar e editar</button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </section>

                            <section>
                                <h2 className="heading-3 mb-3">Seus dashboards</h2>
                                {data.salvos.length === 0 && <p className="text-sm text-ink-4">Nenhum ainda. Duplique um pronto ou comece em branco.</p>}
                                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
                                    {data.salvos.map(d => (
                                        <div key={d.id} className="surface-card surface-card-hover p-5 flex flex-col">
                                            <h3 className="font-semibold">{d.nome}</h3>
                                            <p className="text-xs text-ink-3 mt-1 flex-1">{d.descricao || (d.origem_modelo ? `a partir de "${d.origem_modelo}"` : "")}</p>
                                            <p className="text-[10px] text-ink-5 mt-2">{d.compartilhado ? "compartilhado com a empresa" : "só você"} · atualizado {new Date(d.atualizado_em).toLocaleDateString("pt-BR")}</p>
                                            <div className="flex gap-2 mt-3">
                                                <Link to={`/ads/dashboards/${d.id}`} className="btn-primary text-xs">Abrir</Link>
                                                <button onClick={() => duplicar(d.id)} className="btn-ghost text-xs flex items-center gap-1"><Copy className="h-3.5 w-3.5" /> Duplicar</button>
                                                <button onClick={() => excluir(d)} className="btn-ghost text-xs text-danger-400 ml-auto"><Trash2 className="h-3.5 w-3.5" /></button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </section>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
